
// const BASE_URL = `http://10.168.88.12:9017/v1/consent`

//const BASE_URL = `http://10.168.24.4:9006/consent/v1`

// const BASE_URL =  "https://api.consent.jio.com/consent/v1"

// const BASE_URL = `http://10.168.24.4:9006/consent/v1`

// const BASE_URL =  "https://api.consent.jio.com/consent/v1"

// const TOKEN = `http://10.168.24.4:9006/oauth2/v2.0/token`

const PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY

const BASE_URL = process.env.REACT_APP_BASE_URL
const BASE_URL_BACKUP = `https://api.consentdev.jio.com/consent/v1` 
//const BASE_URL = `http://10.173.152.4:9006/v1/consent`
const BASE_OTP = `http://10.162.6.62:9010` 

const BASE_URL_FOR_COOKIE_CONSENT = `http://10.162.6.75:4000` 
const BASE_URL_FOR_COOKIE_CONSENT_WSO2 = 'https://api.consentdev.jio.com/cookie/v1'

const BASE_URL_TEMP = 'https://api.consentdev.jio.com/consent/v1.3'
 const TOKEN = process.env.REACT_APP_TOKEN

//const TOKEN = `http://10.173.152.4:9006/oauth2/v2.0/token`


/// HELP ICON 
const GET_DATATYPE_ICON = 'labels put on sets/buckets of data which combines data from one or more data categories'
const  GET_DATA_CATEGORY = 'collation of data of a certain kind that results into a logical data-set; difference data categories can be clubbed into a particular data type'
const  GET_PURPOSE = 'the end-use that the business entity intends to put the user/customer to'
const  GET_DATA_PROVIDER = 'the business entity that captures the user/customer data in the first place, and subsequently uses the same for its internal purposes'
const GET_DATA_CONSUMER = 'the business entity that the said data would be shared with, and therefore would be the consumer of that data '
const GET_TEMPLATE_NAME = 'custom name which can be used for easy reference to that template'
const GET_CUSTOMIZED_CONTENT = ' the text that is visible in the Preference Center pop-up '
const  GET_CUSTOMIZED_THEME = ' the appearance of the Preference Center pop-up '


const helpicon = { 
   GET_DATATYPE_ICON,
   GET_DATA_CATEGORY,
   GET_PURPOSE,
   GET_DATA_PROVIDER,
   GET_DATA_CONSUMER,
   GET_TEMPLATE_NAME,
   GET_CUSTOMIZED_CONTENT,
   GET_CUSTOMIZED_THEME,
  
 };

export default helpicon
